export const POSTPAID_D2D = 2
export const PREPAID_D2D = 3
export const CONVERGENT_D2D = 4
export const STB_D2D = 5
export const EL_FIJO_D2D = 6

export const D2D_RESELLER = 'D2D'
